var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaignMessage"},[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"heading"},[_c('div',[_vm._v(_vm._s(_vm.$t("what_are_raising_money")))]),_c('div',{staticClass:"hLine"})]),_c('div',{staticClass:"paragraphMessage"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getDetailMessage)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }